package com.karawek.core.auth.usecase

import com.karawek.core.auth.api.AuthSessionStore
import com.karawek.core.auth.model.AuthSession
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Inject
@SingleIn(AppScope::class)
class SaveAuthSessionUseCase(
    private val sessionStore: AuthSessionStore,
) {
    suspend operator fun invoke(session: AuthSession) {
        sessionStore.write(session)
    }
}
